module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA4CAYAAACPKLr2AAAAAXNSR0IArs4c6QAAAR9JREFUaEPtlrFOAkEURc+YDJ+AnZWFxZpQ+Q/+h5tgR2HpH9CvJvwHnb0/QIg0NNJZG2XAodqACTo7+zBY3G3nncnN2fs265Y3RP7j45h0RhROAdu+HRlsa67mZFAGrQasvDoog1YDVr7uYCh5st6V4iOcEzlLzX07rwNmQS2HQ8kwRu6ycAXc0SWDWd3ZMyyDRzUY+xRhzSA3hPfc0+UtLHhswF4RuWwwtx2pPzOrkuuvyDgLBrznglPm4ZXPXLbRvAI20vTLkAzKYMKAtlhLoiXRkiQMHGRJKmbc0rPWbS9/woermDrL34x74OVPwu1cqoBWwzIogz8ZcI5n4N1qKMW37mDq4kOdK6DVpAzKoNWAlVcHZdBqwMqrg1aDG8BHXR7rpc3tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = UT21
// module chunks = 0